import { useState } from "react";
import YouTube from "react-youtube";
import { useNavigate } from "react-router-dom";

import '../../css/QATestingSection.css';

// ✅ import images
import crossplatform from "../../../assets/icons/crossplatform.png";
import testcase from "../../../assets/icons/testcase.png";
import freemium from "../../../assets/icons/freemium.png";
import realtime from "../../../assets/icons/realtime.png";
import thumbnail from "../../../assets/icons/test.jpeg";
import playIcon from "../../../assets/icons/play-icon.png";

function Feature({ icon, text }) {
  return (
    <div className="d-flex align-items-center gap-3 mb-3">
      <img src={icon} alt="icon" className="feature-icon" />
      <p className="feature-text mb-0">{text}</p>
    </div>
  );
}

export default function QATestingSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(false);
  const [videoKey, setVideoKey] = useState(0);

  const navigate = useNavigate();

  const handlePlay = () => {
    setIsPlaying(true);
    setIsEnded(false);
    setVideoKey((prev) => prev + 1);
  };

  const handleStateChange = (event) => {
    if (event.data === 0) {
      setIsEnded(true);
    }
  };

  return (
    <section className="qa-section py-5">
      <div className="container">

        {/* Heading */}
        <h2 className="qa-heading text-center mb-4">
          Raise your company to the next level with AI-Driven simple QA process
        </h2>

        {/* Features */}
        <div className="row mb-4">
          <div className="col-md-6">
            <Feature icon={crossplatform} text="Flexible cloud and in-house solutions" />
             <Feature
              icon={freemium}
              text={
                <>
                  Generate test cases effortlessly with{" "}
                  <span className="highlight">FrothAI</span>
                </>
              }
            />
            
          </div>

          <div className="col-md-6">
            <Feature icon={testcase} text="Tailored workflows to suit your needs" />
            <Feature icon={realtime} text="Hassle-free teamwork across all team sizes" />
          </div>
        </div>

        {/* VIDEO */}
        <div className="video-wrapper position-relative">

          {!isPlaying && (
            <>
              <img src={thumbnail} alt="video" className="video-thumb" />

              <div className="play-btn">
                <img
                  src={playIcon}
                  alt="play"
                  onClick={handlePlay}
                />
              </div>
            </>
          )}

          {isPlaying && (
            <YouTube
              key={videoKey}
              videoId="KyE6vfv-3fQ"
              opts={{
                width: "100%",
                height: "400",
                playerVars: { autoplay: 1 },
              }}
              onStateChange={handleStateChange}
            />
          )}

          {/* Contact button */}
          {isEnded && (
            <button
              className="contact-btn"
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </button>
          )}

        </div>

      </div>
    </section>
  );
}